import { AUD_MOBILE_BX1047_SINGLE_PIN_LOGIC } from 'shared/map-search/constants/config/experiments';
import { isAbUseExperimentActive } from 'shared/map-search/utils/experiments';
import { validateCianDomain } from 'shared/map-search/utils/validateCianDomain';

import { analyticsMessageHandler, reduxActionMessageHandler } from './messageHandlers';
import { TReduxStore } from './types';
import { isValidMessage, assertStore } from './utils';

export class MessageEventManager {
  private store: TReduxStore;
  private deviceType: string;

  public init(store: TReduxStore) {
    this.store = store;

    window.addEventListener('message', this.processMessage);
  }

  public setDeviceType(deviceType: string) {
    this.deviceType = deviceType;
  }

  public processMessage = (event: MessageEvent) => {
    assertStore(this.store);

    if (!validateCianDomain(event.origin)) {
      return;
    }

    const message = event.data;
    if (!isValidMessage(message)) {
      return;
    }

    const {
      experiments,
      searchResults: { isDotPin: isDotPinClicked },
    } = this.store.getState();

    const isExperimentActive = isAbUseExperimentActive(experiments, AUD_MOBILE_BX1047_SINGLE_PIN_LOGIC, 'B');

    const isDotPin = isExperimentActive && this.deviceType === 'desktop' ? isDotPinClicked : undefined;

    switch (message.type) {
      case 'reduxAction':
        reduxActionMessageHandler({ message, dispatch: this.store.dispatch, isDotPin });
        break;
      case 'analytics':
        analyticsMessageHandler({
          message,
          isDotPin,
        });
        break;
    }
  };
}

export const messageEventManager = new MessageEventManager();
